<wlm-drag-list-custom
  *ngIf="layerGroups?.length && map"
  class="drag-list nested-drag-container drag-container-group"
  [objectsToOrder]="layerGroups"
  [settings]="settingsCustom"
  (somethingChanged)="setLayerGroupPosition()"
  [previewItemClass]="'nested-drag-container'"
>
  <ng-template let-rowDetail #card>
    <div class="layer-group">
      <div class="layer-info">
        <wlm-icon class="vertical-center-icon drag-icon" [icon]="'drag_and_drops'"></wlm-icon>
        <span class="layer-group-name">{{ rowDetail.layerGroupTitle | uppercase }}</span>
      </div>

      <wlm-layers-selector
        class="layers-selector"
        [initialZIndex]="initialZIndex"
        [layers]="rowDetail.layers"
        [map]="map"
        [groupPosition]="rowDetail.position"
        [showLayerTypeIcon]="showLayerTypeIcon"
      ></wlm-layers-selector>
    </div>
  </ng-template>
</wlm-drag-list-custom>
